export default {
  props: {
    tabOnEnter: {
      type: Boolean,
      default: false,
    },
    tabindex: {
      type: String,
      default: null,
    },
  },
  methods: {
    nextField(field) {
      field.parentElement?.parentElement?.nextElementSibling?.querySelector('input')?.focus()
    },
  },
}
